var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7478 19.9999H0.847656V3.25192H4.48099V16.7472H16.7478V19.9999Z",
    fill: "#60DFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7473 6.5054C18.5437 6.5054 20 5.04912 20 3.2527C20 1.45628 18.5437 0 16.7473 0C14.9509 0 13.4946 1.45628 13.4946 3.2527C13.4946 5.04912 14.9509 6.5054 16.7473 6.5054Z",
    fill: "#60DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLinea);
export default __webpack_public_path__ + "static/media/blue-linea.274dbf085fd0ea6d04414e14531a4432.svg";
export { ForwardRef as ReactComponent };